import {
  AfterContentInit,
  ChangeDetectorRef,
  Directive,
  ElementRef,
  HostListener,
  Input,
  OnDestroy,
} from '@angular/core';
import { AbstractControl, NgControl } from '@angular/forms';
import { Observable, Subject } from 'rxjs';
import { takeUntil } from 'rxjs/operators';

@Directive({
  selector: '[appPhoneNumber]',
})
export class PhoneDirective implements AfterContentInit, OnDestroy {
  @Input() formatRequest?: Observable<void>;

  private invalidEvents: string[] = ['Backspace', 'Delete', 'ArrowUp', 'ArrowDown', 'ArrowLeft', 'ArrowRight'];

  private element: HTMLInputElement;

  private destroyed$: Subject<void> = new Subject<void>();

  constructor(private el: ElementRef, private control: NgControl, private changeDetectorRef: ChangeDetectorRef) {
    this.element = this.el.nativeElement;
    this.element.type = 'tel';
  }

  @HostListener('keyup', ['$event'])
  @HostListener('keypress', ['$event'])
  public onEvent(event: KeyboardEvent): void {
    const input: string = this.element.value.replace(/\D/g, '');
    if (!this.invalidEvents.includes(event.key)) {
      const selection = document?.getSelection()?.toString() || window?.getSelection()?.toString();
      if (selection) {
        const selectionText: string = selection.replace(/\D/g, '');
        if (selectionText.length === 11 || new RegExp(/\D/g).test(event.key)) {
          event.preventDefault();
        }
      } else if (input.length === 10 || new RegExp(/\D/g).test(event.key)) {
        event.preventDefault();
      }
      this.getFormattedValue();
    }
  }

  ngOnDestroy() {
    this.destroyed$.next();
    this.destroyed$.complete();
  }

  ngAfterContentInit(): void {
    if (this.formatRequest) {
      this.formatRequest.pipe(takeUntil(this.destroyed$)).subscribe(() => this.getFormattedValue());
    }
    this.getFormattedValue();
    this.changeDetectorRef.detectChanges();
  }

  private getFormattedValue() {
    const formControl: AbstractControl | null = this.control.control;
    let valueNumber = this.element.value.replace(/\D/g, '');

    const match = valueNumber.match(/^(\d{0,3})(\d{0,3})(\d{0,4})$/);
    if (match?.[1].length) {
      valueNumber = `${match[1]}`;
    }
    if (match?.[2].length) {
      valueNumber = `(${match[1]}) ${match[2]}`;
    }
    if (match?.[3].length) {
      valueNumber = `(${match[1]}) ${match[2]}-${match[3]}`;
    }
    formControl?.setValue(valueNumber);
  }
}
